/* @flow */

import { DMSConsumer } from 'CoreConsumers';
import type { $Dealer } from 'CoreTypes';
import type { $WidgetEnvConfiguration } from '../types';
import type { $WidgetSettings } from '../types/WidgetSettings';
import { getEnvConfiguration } from '../environments';
import { getDMSEndpointURL } from 'CoreUtils/EndpointUtils';

const SEARCH_FIELD_VALUE_CHANGE = 'dsw/advancedSearch/SEARCH_FIELD_VALUE_CHANGE';
const SEARCH_FIELD_VALUE_REMOVE = 'dsw/advancedSearch/SEARCH_FIELD_VALUE_REMOVE';
const FIND_DEALERS_REQUEST = 'dsw/advancedSearch/FIND_DEALERS_REQUEST';
const FIND_DEALERS_SUCCESS = 'dsw/advancedSearch/FIND_DEALERS_SUCCESS';
const FIND_DEALERS_FAILURE = 'dsw/advancedSearch/FIND_DEALERS_FAILURE';
const DEALER_SELECTED = 'dsw/advancedSearch/DEALER_SELECTED';
const WIDGET_RESET = 'dsw/advancedSearch/WIDGET_RESET';

export const PAGE_DEALERS: number = 20;

type $SearchField = {
  fieldKey: string,
  value: string
};

export type $State = {
  searchFields: Array<$SearchField>,
  dealersList: Array<$Dealer>,
  dealersCount: number,
  selectedDealer: string,
  loading: boolean,
  result: boolean
};

const initialState: $State = {
  searchFields: [],
  dealersList: [],
  dealersCount: -1,
  selectedDealer: '',
  loading: false,
  result: true
};

export default (state: $State, action: Object) => {
  if (!state) state = initialState;
  switch (action.type) {
    case SEARCH_FIELD_VALUE_CHANGE:
      if (
        state.searchFields.findIndex(field => {
          return field.fieldKey === action.fieldKey;
        }) > -1
      ) {
        return {
          ...state,
          searchFields: state.searchFields.map(field => {
            if (field.fieldKey !== action.fieldKey) return field;
            else
              return {
                ...field,
                value: action.value
              };
          })
        };
      } else {
        return {
          ...state,
          searchFields: [
            ...state.searchFields,
            {
              fieldKey: action.fieldKey,
              value: action.value
            }
          ]
        };
      }

    case SEARCH_FIELD_VALUE_REMOVE:
      return {
        ...state,
        searchFields: state.searchFields.filter(field => {
          return field.fieldKey !== action.fieldKey;
        })
      };

    case FIND_DEALERS_REQUEST:
      return {
        ...state,
        loading: true,
        selectedDealer: ''
      };

    case FIND_DEALERS_SUCCESS:
      return {
        ...state,
        dealersCount: action.dealersCount,
        dealersList: action.dealersList,
        loading: false,
        result: true
      };

    case FIND_DEALERS_FAILURE:
      return {
        ...state,
        loading: false,
        result: false
      };

    case DEALER_SELECTED:
      return {
        ...state,
        selectedDealer: action.externalId
      };

    case WIDGET_RESET:
      return initialState;

    default:
      return initialState;
  }
};

export const changeSearchFieldValue = (fieldKey: string, value?: string) => {
  if (value && value.length > 0) {
    return {
      type: SEARCH_FIELD_VALUE_CHANGE,
      fieldKey,
      value
    };
  } else {
    return {
      type: SEARCH_FIELD_VALUE_REMOVE,
      fieldKey
    };
  }
};

export const submitSearchForm = () => ({
  type: FIND_DEALERS_REQUEST
});

export const findDealersSuccess = (dealersCount: number, dealersList: Array<$Dealer>) => ({
  type: FIND_DEALERS_SUCCESS,
  dealersCount,
  dealersList
});

export const findDealersFailure = () => ({
  type: FIND_DEALERS_FAILURE
});

export const composeFindDealersCriteria = (searchFields: Array<Object>) => {
  const criteria = {};
  searchFields.forEach(field => {
    const keys: Array<string> = field.fieldKey.split('.');
    let criteriaObj = criteria;
    for (let i = 0; i < keys.length; i++) {
      if (i === keys.length - 1) criteriaObj[keys[i]] = field.value;
      else if (!criteriaObj.hasOwnProperty([keys[i]])) criteriaObj[keys[i]] = {};
      criteriaObj = criteriaObj[keys[i]];
    }
  });
  return criteria;
};

export const findDealers = (
  settings: $WidgetSettings,
  searchFields: Array<Object>,
  page: number
) => (dispatch: Function) => {
  dispatch(submitSearchForm());
  const criteria = composeFindDealersCriteria(searchFields);
  const req = {
    page,
    criteria,
    size: PAGE_DEALERS
  };

  /*
   * console.log('MB DL :: search criteria');
   * console.log(req);
   *
   */
  const envConfig: $WidgetEnvConfiguration = getEnvConfiguration(settings.env);
  const dms = new DMSConsumer(getDMSEndpointURL(settings, envConfig));
  dms
    .searchDealersByCriteria(req)
    .then(res => {
      setTimeout(() => {
        if (res && res.status === 200) {
          dispatch(findDealersSuccess(res.data.total, res.data.results));
        } else {
          dispatch(findDealersFailure());
        }
      }, 500);
    })
    .catch(error => { // eslint-disable-line no-unused-vars
      dispatch(findDealersFailure());
    });
};

export const selectDealer = (externalId: string) => ({
  type: DEALER_SELECTED,
  externalId
});

export const resetWidget = () => ({
  type: WIDGET_RESET
});
